// src/components/ProfilePictureUpload.js
import React from 'react';
import { User, X, Upload } from 'lucide-react';

const ProfilePictureUpload = ({ currentImage, onImageChange, onImageRemove }) => {
  const fileInputRef = React.useRef(null);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > 5 * 1024 * 1024) {
        alert('File is too large. Maximum size is 5MB.');
        return;
      }
      if (!file.type.startsWith('image/')) {
        alert('Only image files are allowed.');
        return;
      }
      onImageChange(file);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    if (file) {
      if (file.size > 5 * 1024 * 1024) {
        alert('File is too large. Maximum size is 5MB.');
        return;
      }
      if (!file.type.startsWith('image/')) {
        alert('Only image files are allowed.');
        return;
      }
      onImageChange(file);
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  return (
    <div className="w-full">
      <label className="block text-sm font-medium mb-2">Profile Picture</label>
      <div
        className="border-2 border-dashed border-gray-300 rounded-lg p-4 text-center"
        onDrop={handleDrop}
        onDragOver={handleDragOver}
      >
        {currentImage ? (
          <div className="relative inline-block">
            <img
              src={typeof currentImage === 'string' ? currentImage : URL.createObjectURL(currentImage)}
              alt="Profile"
              className="w-32 h-32 rounded-full object-cover mx-auto"
            />
            <button
              type="button"
              onClick={() => onImageRemove()}
              className="absolute top-0 right-0 bg-red-500 text-white rounded-full p-1 hover:bg-red-600 transition-colors"
            >
              <X size={16} />
            </button>
          </div>
        ) : (
          <div className="text-gray-500">
            <User size={48} className="mx-auto mb-2" />
            <p className="text-sm">
              Drag and drop an image here, or{' '}
              <button
                type="button"
                onClick={() => fileInputRef.current?.click()}
                className="text-black font-medium hover:underline"
              >
                browse
              </button>
            </p>
            <p className="text-xs text-gray-400 mt-1">Maximum file size: 5MB</p>
          </div>
        )}
        <input
          type="file"
          ref={fileInputRef}
          onChange={handleFileChange}
          accept="image/*"
          className="hidden"
        />
      </div>
    </div>
  );
};

export default ProfilePictureUpload;